import { render, staticRenderFns } from "./ReviewsSection.vue?vue&type=template&id=52590b90&scoped=true&"
import script from "./ReviewsSection.vue?vue&type=script&lang=ts&"
export * from "./ReviewsSection.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsSection.vue?vue&type=style&index=0&id=52590b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52590b90",
  null
  
)

export default component.exports